import { Injectable, Inject, DOCUMENT } from '@angular/core';


@Injectable()
export class GlobalRefService {
  private window: Window;

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.window = this.document.defaultView;
  }

  // get window object
  _window(): any {
    return this.window;
  }

  // get document object
  _document(): any {
    return this.document;
  }

  // wrapper for window object
  get nativeWindow(): any {
    return this._window();
  }

  // wrapper for document object
  get nativeDocument(): any {
    return this._document();
  }
}